"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonStyled = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ButtonStyled = (0, styled_components_1.default)(antd_1.Button) `
  flex: 1;
  width: 100%;
  border-radius: 5px;
  width: 100%;
`;
